import { PlayArrow } from "@mui/icons-material";
import { Badge, Card, CardContent, Dialog, DialogContent, Grid, Tooltip } from "@mui/material";
import React, { useState, useEffect } from "react";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { LeftArrow, RightArrow } from "./CarrouselArrow/Carrousel-arrow";
import "./Carrousel.css";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import ReplayVideo from "../Player/ReplayVideo";
import { useDispatch, useSelector } from "react-redux";
import ReactAddToCalendar from "../ReactAddToCalendar/ReactAddToCalendar";
import "../ReactAddToCalendar/styles/ReactAddToCalendar.scss";

export function Carrousel({
  getVideos,
  setVideos,
  setPage,
  addVideoToFavorites,
  removeVideoFromFavorites,
  type,
  data,
  userId,
  typeId,
  levelId,
}) {
  let list = data ? data : [];
  const [isFetching, setIsFetching] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const token = useSelector((state) => state.message.token);
  const showAllVideos = useSelector((state) => state.dashboardCarrouselVideos.showAllVideos);
  const { i18n } = useTranslation();
  let icon = { "calendar-plus-o": "left" };

  const { videos, page } = useSelector((state) => {
    // Handle special types
    if (type === "favorites") {
      return state.dashboardCarrouselVideos.favorite;
    }
    if (type === "last-played") {
      return state.dashboardCarrouselVideos.lastPlayedVideos;
    }
    if (type === "latest-videos") {
      return state.dashboardCarrouselVideos.latestVideos;
    }
    
    // Handle dynamic categories by typeId
    if (typeId && state.dashboardCarrouselVideos.categories[typeId]) {
      return state.dashboardCarrouselVideos.categories[typeId];
    }
    
    // Return default if category not found
    return { videos: [], page: 1 };
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (data === undefined || !data) {
      resetAndFetchData();
    }
    // eslint-disable-next-line
  }, [token, showAllVideos, i18n.language, type, typeId]);

  useEffect(() => {
    if (!isFetching) return;
    fetchMoreListItems();
    // eslint-disable-next-line
  }, [isFetching, token]);

  const fetchMoreListItems = () => {
    fetchData();
    setIsFetching(false);
  };

  const fetchData = async (requestedPage = page) => {
    const languageParam = !showAllVideos ? { language: i18n.language } : {};
    let queryParams = `page=${requestedPage}`;

    if (type === "last-played" && !showAllVideos) {
      queryParams = `${queryParams}&language=${i18n.language}`;
    }

    if (typeId) {
      queryParams = { page: requestedPage, typeId: typeId, ...languageParam };
    }

    setTimeout(async () => {
      dispatch(
        getVideos(
          type === "latest-videos"
            ? (showAllVideos ? undefined : { ...languageParam })
            : type === "favorites"
            ? { page: requestedPage, favourites: true, ...languageParam }
            : queryParams
        )
      );
    }, 1000);
  };

  const resetAndFetchData = () => {
    if (setPage) {
      dispatch(setPage({ page: 1, type, typeId }));
    }

    fetchData(1);
  };

  function VideoCard({ item, key }) {
    const visibility = React.useContext(VisibilityContext);

    return (
      <Card
        className="video-card"
        tabIndex={0}
        style={{ position: "relative", boxShadow: "none" }}
      >
        <img src={item.thumbnailUrl} alt="" className="video-slider-media" />
        <div className="overlay"></div>
        <button
          disabled={false}
          style={{
            display: "none",
          }}
          className="arrow-buttons play-button"
          onClick={() => {
            setOpen(true);
            setSelectedVideo(item);
          }}
        >
          <PlayArrow />
        </button>
        <CardContent className="video-card-content video-card-details">
          <p className="video-scroll-menu-text font-weight-bold">
            {t(item.videoType)}
          </p>
          <p className="video-scroll-menu-text">{`${item.firstName} ${item.lastName}`}</p>
          <ReactAddToCalendar
            className="react-all-videos-add-to-calendar"
            buttonTemplate={icon}
            event={{
              btnTitle: "",
              title: item.videoTitle,
              description: `${item.notes ? item.notes + " " : ""}Video Url:${
                item.videoUrl
              }`,
              location: "Denmark",
              startTime: item.startTime,
              endTime: item.startTime,
            }}
          />

          {!item.isFavourite && (
            <button
              className="favorite-button"
              onClick={() => {
                addVideoToFavorites(
                  item.sessionId
                    ? {
                        sessionVideoId: item.id,
                        videoType: item.videoType,
                        videoTypeId: item.videoTypeId,
                        isFavourite: true,
                      }
                    : {
                        videoId: item.id,
                        videoType: item.videoType,
                        videoTypeId: item.videoTypeId,
                        isFavourite: true,
                      }
                );
              }}
            >
              <FavoriteBorderIcon className="favorite-icon" />
            </button>
          )}
          {item.isFavourite && (
            <button
              className="favorite-button"
              onClick={() => {
                removeVideoFromFavorites(
                  item.sessionId
                    ? {
                        sessionVideoId: item.id,
                        videoType: item.videoType,
                        videoTypeId: item.videoTypeId,
                        isFavourite: false,
                      }
                    : {
                        videoId: item.id,
                        videoType: item.videoType,
                        videoTypeId: item.videoTypeId,
                        isFavourite: false,
                      }
                );
              }}
            >
              <FavoriteIcon className="favorite-icon" />
            </button>
          )}
        </CardContent>
      </Card>
    );
  }

  const getItems = () =>
    Array(20)
      .fill(0)
      .map((_, ind) => ({ id: `element-${ind}` }));

  const createScrollMenu = (data) => {
    return (
      <ScrollMenu
        LeftArrow={LeftArrow}
        RightArrow={
          <RightArrow
            changeStateValue={() => {
              setIsFetching(true);
            }}
          />
        }
        className="scroll-menu"
      >
        {data.map((item, index) => (
          <VideoCard item={item} itemId={"video-" + index} key={index} />
        ))}
      </ScrollMenu>
    );
  };

  return (
    <div className="horizontal-scroll-menu">
      <Dialog
        fullScreen
        onClose={() => {
          setOpen(false);
        }}
        open={open}
        PaperProps={{
          sx: {
            backgroundColor: "#000",
          },
        }}
      >
        <DialogContent
          sx={{
            p: { xs: 2, sm: 3 },
            backgroundColor: "transparent",
          }}
        >
          <ReplayVideo
            onClose={() => {
              setOpen(false);
            }}
            selectedVideo={selectedVideo}
          />
        </DialogContent>
      </Dialog>

      {videos &&
        videos !== undefined &&
        videos.length > 0 &&
        createScrollMenu(videos)}
      {/* {(!videos || videos === undefined || videos.length === 0) && (
        <Grid
          item
          className="font-weight-bold scroll-menu-title"
          style={{ fontWeight: "normal" }}
        >
          <p>{t("No Videos Found")}</p>
        </Grid>
      )} */}
    </div>
  );
}
